import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check if user is authenticated (has entered the correct code)
  const isAuthenticated = sessionStorage.getItem('resume_authenticated') === 'true';
  
  // If authenticated, show the protected content
  // If not authenticated, redirect to the lock page
  return isAuthenticated ? children : <Navigate to="/resume-access" replace />;
};

export default ProtectedRoute;
